module.exports = __webpack_public_path__ + "static/media/Checkbox_ok.52c5a6cc.svg";